import { gql } from '@graphql/__generated__';

export const NOTIFICATION_SETTING_FIELDS = gql(/* GraphQL */ `
  fragment NotificationSettingFields on notification_settings {
    type
    is_active
    requires_channel
    modules
    country_codes
    audience
    order_nr
    created_at
    updated_at
    label_en
    label_fr
    label_de
    label_it
    label_es
    label_pl
    label_pt
    description_en
    description_fr
    description_de
    description_it
    description_es
    description_pl
    description_pt
    email_available
    email_default
    sms_available
    sms_default
    push_available
    push_default
    team_leader_cc_available
    team_leader_cc_default
  }
`);

export const GET_USER_NOTIFICATION_SETTINGS = gql(/* GraphQL */ `
  query GetUserNotificationSettings($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      first_name
      last_name
      phone_numbers(limit: 1) {
        id
      }
      # Push reaches agents only once the RealAdvisor Pro app registered a token.
      pro_app_tokens: push_notification_tokens(
        where: { app_id: { _eq: "realadvisor-pro" } }
        limit: 1
      ) {
        id
      }
      tenant {
        id
        country_code
      }
      ...UserActiveModuleGrants
      teams_users(
        where: { is_leader: { _eq: true }, deactivated: { _eq: false } }
      ) {
        team_id
      }
    }
    notification_settings(order_by: [{ order_nr: asc }, { type: asc }]) {
      ...NotificationSettingFields
      user_preferences(where: { user_id: { _eq: $userId } }) {
        email_enabled
        sms_enabled
        push_enabled
        team_leader_cc_enabled
      }
    }
  }
`);

export const SAVE_USER_NOTIFICATION_PREFERENCES = gql(/* GraphQL */ `
  mutation SaveUserNotificationPreferences(
    $objects: [user_notification_preferences_insert_input!]!
    $updateColumns: [user_notification_preferences_update_column!]!
  ) {
    insert_user_notification_preferences(
      objects: $objects
      on_conflict: {
        constraint: user_notification_preferences_pkey
        update_columns: $updateColumns
      }
    ) {
      returning {
        user_id
        type
        email_enabled
        sms_enabled
        push_enabled
        team_leader_cc_enabled
      }
    }
  }
`);
